import { clearTokens, setTokens } from "@/domains/auth/auth-storage";
import { refreshTokenApi } from "@/domains/auth/auth.api";
import { navigateTo } from "@/shared/utils/navigate";

let isRefreshing = false;
let failedQueue: Array<{ resolve: (value?: any) => void; reject: (reason?: any) => void }> = [];

/**
 * Process the queue of failed requests
 */
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

/**
 * Check if refresh is in progress
 */
export const isRefreshingToken = () => isRefreshing;

/**
 * Add request to failed queue
 */
export const addToFailedQueue = (resolve: (value?: any) => void, reject: (reason?: any) => void) => {
  failedQueue.push({ resolve, reject });
};

/**
 * Refresh access token using refresh token
 */
export const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      addToFailedQueue(resolve, reject);
    });
  }

  isRefreshing = true;

  try {
    const refreshResponse = await refreshTokenApi();

    if (refreshResponse.status === "success" && refreshResponse.data) {
      const newTokens = refreshResponse.data;

      setTokens(newTokens);
      processQueue(null, newTokens.access_token);

      return newTokens.access_token;
    }

    throw new Error("Falha no refresh token: Resposta inesperada.");
  } catch (refreshError: any) {
    processQueue(refreshError, null);
    clearTokens();
    navigateTo("/sign-out");

    throw refreshError;
  } finally {
    isRefreshing = false;
  }
};
